module.exports = __webpack_public_path__ + "static/media/hemmeleg.1dbb99ad.m4a";